import { api } from "./configs/axiosConfigs"

export const BranchOfficeAPI = {
    getBranchOffice: async (data:any) => {
        const response = await api.get(
            '/branchoffice', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getBranchOfficeByCompany: async (data:any) => {
        const response = await api.get(
            '/branchoffice/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getTypesBranches: async (data:any) => {
        const response = await api.get(
            '/branchoffice/listTypesBranches', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createBranchOffice: async (data: any) => {
        const response = await api.post(
            '/branchoffice/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editBranchOffice: async (idbranchoffice: number, data: any) => {
        const response = await api.patch(
            `/branchoffice/${idbranchoffice}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteBranchOffice: async (idbranchoffice: number) => {
        const response = await api.delete(
            `/branchoffice/${idbranchoffice}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}